module.exports = __webpack_public_path__ + "img/aq.c959788b.svg";